import { defineMessages } from 'react-intl';

export const i18n: {
	frameAboveImageDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	frameAboveImageLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	imageBackgroundDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // We will eventually use these translations when full background layout is properly introduced
	imageBackgroundLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	solidColorBackgroundDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	solidColorBackgroundLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	splitDesignContentFirstDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	splitDesignContentFirstLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	splitDesignImageFirstDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	splitDesignImageFirstLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	splitDesignContentFirstLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label',
		defaultMessage: 'Split design (content first)',
		description:
			'Label for the split design (content first) layout option in the spotlight extension config panel, where content appears on the left and a large image on the right.',
	},
	splitDesignContentFirstDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description',
		defaultMessage: 'Large image on the right with lots of room for content',
		description:
			'Descriptive text for the split design (content first) layout option shown in the spotlight config panel, explaining the visual arrangement.',
	},
	splitDesignImageFirstLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label',
		defaultMessage: 'Split design (image first)',
		description:
			'Label for the split design (image first) layout option in the spotlight extension config panel, where a large image appears on the left and content on the right.',
	},
	splitDesignImageFirstDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description',
		defaultMessage: 'Large image on the left with lots of room for content',
		description:
			'Descriptive text for the split design (image first) layout option shown in the spotlight config panel, explaining the visual arrangement.',
	},
	solidColorBackgroundLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label',
		defaultMessage: 'Solid color background',
		description: 'Solid color background layout option label',
	},
	solidColorBackgroundDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description',
		defaultMessage: 'Content in front of a full-width color',
		description: 'Solid color background layout option description',
	},
	frameAboveImageLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label',
		defaultMessage: 'Content frame inside image',
		description:
			'Label for the content-frame-inside-image layout option in the spotlight extension config panel, where a text box overlays a large background image.',
	},
	frameAboveImageDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description',
		defaultMessage: 'Text box overlay on a large image',
		description: 'Frame above image layout option description',
	},
	// We will eventually use these translations when full background layout is properly introduced
	imageBackgroundLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label',
		defaultMessage: 'Image background',
		description:
			'Label for the image background layout option in the spotlight extension config panel, where a full-size image is displayed behind the content.',
	},
	imageBackgroundDescription: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description',
		defaultMessage: 'Full-size image behind your content',
		description: 'Image background layout option description',
	},
});
